<template>
  <div class='page-start'>
    <mdb-container class="col-10 pb-3" fluid>

      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
          Success! Submitted QPR!
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
          There was an error submitting QPR. Please try again! Error Code P2
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6" @closeAlert="p6=false" dismiss>
				There was an error retrieving data from the server! Please try again later.
			</mdb-alert>

      <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">QPR Submission Form</h3>
        <mdb-card-body>
          <form @submit.prevent="" class="was-validated">
            <mdb-row>
              <mdb-col>
                <mdb-input class="mb-3" v-model="title" label="Title" placeholder="Brief Title for Problem or Enhancement" 
                invalid-feedback="Please Input QPR Title" valid-feedback="Looks Good!" maxlength="120" required/>
              </mdb-col>
            </mdb-row>
            <br>
            <mdb-row>
              <mdb-col>
                <mdb-input class="mb-3" v-model="author" label="Author" placeholder="Your Name" disabled maxlength="60"/>
              </mdb-col>
            </mdb-row>
            <br>
            <mdb-row>
              <mdb-col>
                <mdb-input class="mb-3" v-model="company" label="Company" placeholder="Company Name" maxlength="60" 
                invalid-feedback="Please Input Your Company Name" valid-feedback="Looks Good!" required/>
              </mdb-col>
            </mdb-row>
            <br>
            <mdb-row>
              <mdb-col>
                <mdb-select :class="{'is-invalid': !foundIn,'is-valid': foundIn}" class="mb-3" label="Found In" @getValue="setProjects" v-model="projectOptions" required/>
                <div v-if="!foundIn" class="invalid-feedback d-block">
                  Please select an option.
                </div>
                <div v-else class="valid-feedback d-block">
                  Looks Good!
                </div>
              </mdb-col>
            </mdb-row>
            <br>
            <mdb-row>
              <mdb-col>
                <mdb-input class="mb-3" v-model="softwareVersion" label="Software Version" 
                placeholder="Version of product or prototype referred to" maxlength="60" required @change="checkVersion" />
                <div v-if="!validVersion" class="invalid-feedback d-block">
                  Please enter a valid version.
                </div>
                <div v-else class="valid-feedback d-block">
                  Looks Good!
                </div>
              </mdb-col>
            </mdb-row>
            <br>
            <mdb-row>
              <mdb-col>
                <mdb-select :class="{'is-invalid': !foundDuring,'is-valid': foundDuring}" v-model="foundDuringOptions" @getValue="setFoundDuring" label="Found During"/>
                <div v-if="!foundDuring" class="invalid-feedback d-block">
                  Please select an option.
                </div>
                <div v-else class="valid-feedback d-block">
                  Looks Good!
                </div>
              </mdb-col>
            </mdb-row>
            <br>
            <!--
            <mdb-row>
              <mdb-col>
                <h5 class="h5" style="text-align: left;">Constraint On</h5>
                <mdb-form-inline>
                  <mdb-input type="radio" id="constraint-none" name="constraint-none" radioValue="None" v-model="constraintOn" label="None" checked/>
                  <mdb-input type="radio" id="constraint-test" name="constraint-test" radioValue="Test" v-model="constraintOn" label="Test" />
                  <mdb-input type="radio" id="constraint-release" name="constraint-release" radioValue="Release" v-model="constraintOn" label="Release" />
                </mdb-form-inline>
              </mdb-col>
            </mdb-row>
            <br>
            -->
            <mdb-row>
              <mdb-col>
                <mdb-input class="mb-3" v-model="currentFunction" label="Current Functionality" placeholder="Provide brief description of the existing behavior" 
                invalid-feedback="Please Input Current Behavior" valid-feedback="Looks Good!" required maxlength="300" />
                <p class="mt-n3" style="text-align: left; " :style="{'color': currentCharStyle}" >{{ 300 - currentFunction.length }} characters remaining</p>
              </mdb-col>
            </mdb-row>
            <br>
            <mdb-row>
              <mdb-col>
                <mdb-input class="mb-3" v-model="expectedFunction" label="Expected Functionality" placeholder="Provide brief description of the desired behavior" 
                invalid-feedback="Please Input Expected Behavior" valid-feedback="Looks Good!" required maxlength="300" />
                <p class="mt-n3" style="text-align: left;" :style="{'color': expectedCharStyle}">{{ 300 - expectedFunction.length }} characters remaining</p>
              </mdb-col>
            </mdb-row>

            <mdb-row>
              <mdb-col>
                <mdb-select :class="{'is-invalid': !priority,'is-valid': priority}" class="mb-3" v-model="priorityOptions" @getValue="setPriority" label="Priority"/>
                <p class="mt-n3" style="text-align: left;">1 - High, 5 - Low</p>
                <div v-if="!priority" class="invalid-feedback d-block">
                  Please select an option.
                </div>
                <div v-else class="valid-feedback d-block">
                  Looks Good!
                </div>
              </mdb-col>
            </mdb-row>
            <br>
            <mdb-btn class='QuadrusButton' v-on:click="submitQPR" type="submit" v-if="!submitProcessing">Submit</mdb-btn>
            <mdb-btn class='QuadrusButton' v-if="submitProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Processing...
            </mdb-btn>

            <br>
            <mdb-btn color="danger" v-on:click="clearQPRForm">Clear</mdb-btn>
          </form>
        </mdb-card-body>
      </mdb-card>
    </mdb-container>
  </div>
</template>

<script>
import { mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbBtn, mdbSelect, mdbCol, mdbRow, mdbAlert } from 'mdbvue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import * as sendEmail from '@/assets/js/email.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

export default {
	name: 'QPRForm',
	components: {
    mdbInput,
    mdbCard,
    mdbCardBody,
    mdbContainer,
    mdbBtn,
    mdbSelect,
    mdbCol, 
    mdbRow,
    mdbAlert
	},
  data() {
    return {

      p1: false,
      p2: false,
      p6: false,

      title: "",
      author: "",
      company: '',
      dateSubmitted: new Date(),
      foundIn: "",
      softwareVersion: "",
      foundDuring: "",
      //constraintOn: "None",
      projectOptions: [],
      msgIds: [],
      priorityOptions: [{text: "1", value: "1"},{text:"2", value: "2"},{text:"3", value: "3"},{text:"4", value: "4"},{text:"5", value: "5"}],
      priority: '',
      validVersion: false,

      currentFunction: "",
      currentCharStyle: "#007E33",

      expectedFunction: "",
      expectedCharStyle: "#007E33",

      submitProcessing: false,

      foundDuringOptions: [
        { text: "Analysis", value: "Analysis" },
        { text: "Design", value:"Design" },
        { text: "Code / Unit Test", value: "Code / Unit Test" },
        { text: "Acceptance Test", value: "Acceptance Test" },
        { text: "In-Service Use", value: "In-Service Use" },
        { text: "Review", value: "Review" },
        { text: "Internal Training", value: "Internal Training" },
        { text: "FQT Dry Run", value: "FQT Dry Run" },
        { text: "FQT", value: "FQT" },
        { text: "Other", value: "Other" }
      ]
    }
  },
  methods: {

    clearQPRForm: function() {
      this.title = "";
      this.foundIn = "";
      this.softwareVersion = "";
      this.priority = "";

      this.foundDuring = "";
      //this.constraintOn = "None";
      this.currentFunction = "";
      
      this.expectedFunction = "";
      this.msgIds = [];
      this.foundDuringOptions = [
        { text: "Analysis", value: "Analysis" },
        { text: "Design", value:"Design" },
        { text: "Code / Unit Test", value: "Code / Unit Test" },
        { text: "Acceptance Test", value: "Acceptance Test" },
        { text: "In-Service Use", value: "In-Service Use" },
        { text: "Review", value: "Review" },
        { text: "Internal Training", value: "Internal Training" },
        { text: "FQT Dry Run", value: "FQT Dry Run" },
        { text: "FQT", value: "FQT" },
        { text: "Other", value: "Other" }
      ];
      this.populateProjects();
      
    },

    //sets priority value
    setPriority: function(value){
      this.priority = value;
    },

    getLoggedInUser: async function () {
      let token = this.$store.getters.getToken;      
      try 
			{
				let response = await DatabaseLib.getRequest('strapiDatabase','users/me',token);
				let tempFName = response.data.firstName;
				let tempLName = response.data.lastName;

				return tempFName + " " + tempLName;
			} 
			catch (error)
			{
				console.log(error);
				window.scroll({top: 0, behavior: 'smooth'});
				this.p6 = true;
				return;
			}
    },

    validate: function(){
      let versionRegex = /^[0-9]+(\.[0-9]+)*$/;
      let isValid = false;
      let versionValid = false;
      if(this.softwareVersion != '' && versionRegex.test(this.softwareVersion)){
        versionValid = true;
      }
      if(this.title != '' && this.author != '' && this.company != '' && this.foundIn && this.foundDuring && versionValid 
        && this.currentFunction != '' && this.expectedFunction != '' && this.priority){
        isValid = true;
      } else {
        isValid = false;
      }
      return isValid;
    },

    submitQPR: async function() {
      if(!this.validate()){
        this.p2 = true;
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }

      this.submitProcessing = true;
      let token = this.$store.getters.getToken;

      this.title = sanitizeInput(this.title, this.$sanitize);
      this.author = sanitizeInput(this.author, this.$sanitize);
      this.company = sanitizeInput(this.company, this.$sanitize);
      this.foundIn = sanitizeInput(this.foundIn, this.$sanitize);
      this.softwareVersion = sanitizeInput(this.softwareVersion, this.$sanitize);
      this.foundDuring = sanitizeInput(this.foundDuring, this.$sanitize);
      this.currentFunction = sanitizeInput(this.currentFunction, this.$sanitize);
      this.expectedFunction = sanitizeInput(this.expectedFunction, this.$sanitize);
      this.priority = sanitizeInput(this.priority, this.$sanitize);
      
      let data = {
        data: {
          title: this.title,
          author: await this.getLoggedInUser(),
          authorUsername: this.$store.getters.getUser,
          company: this.company,
          dateSubmitted: new Date(this.dateSubmitted),
          foundIn: this.foundIn,
          softwareVersion: this.softwareVersion,
          foundDuring: this.foundDuring,
          currentFunction: this.currentFunction,
          expectedFunction: this.expectedFunction,
          status: "Waiting on approval",
          notifications: this.msgIds,
          submissionPriority: this.priority
        }
      }
      let qpr_submission = [];
        try {
          qpr_submission = await DatabaseLib.postRequest('strapiDatabase','submitted-qpr',token,data);
          this.p1 = true;
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2 = true;
          this.submitProcessing = false;
          return;
        }
        // send messages
        this.notifyUsers(qpr_submission);
      this.submitProcessing = false;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    notifyUsers: async function(qpr_submission){
      let token = this.$store.getters.getToken; 
      let notification = "QPR #"+ qpr_submission.data.data.id +" ready to Review for "  + this.foundIn;
      let emailNotification = "You have a new QPR to review for " + this.foundIn + " version " + this.softwareVersion + "<br>";
      emailNotification += "Title: " + this.title + "<br>";
      let data = [];
      let PM_user = "";
      let PM_email = "";

      try{
        // Get PM and current user emails
        let query = "filters[ProjectName][$eq][0]="+ this.foundIn;
        let response = await DatabaseLib.getRequest('strapiDatabase','projects',token,query);
        if(response.data.data.length >= 0 && response.data.data[0].attributes.ProjectManager){
          query = "filters[username][$eq][0]="+ response.data.data[0].attributes.ProjectManager;
          response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
          PM_user = response.data[0].username;
          PM_email = response.data[0].email;
        }        

        if(PM_user && PM_email){
          data = {
            data:{
              details: notification,
              notified: false,
              username: PM_user,
              userEmail: PM_email,
              type: "QPR"
            }
          }
          let res = await DatabaseLib.postRequest('strapiDatabase','notifications',token,data);
          this.msgIds.push(res.data.data.id);
          data = {
            data: {
              notifications: this.msgIds
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','submitted-qpr',token,qpr_submission.data.data.id,data);
          try{
            await sendEmail(PM_email, "New QPR Submitted", emailNotification, token, "ReviewQPR&id="+qpr_submission.data.data.id, []);
          } catch (error) {
            console.log(error);
          }
        }
        try{
          await sendEmail(this.$store.getters.getEmail, "New QPR Submitted", "Your QPR has been submitted. Title: " + this.title, token, "ViewSubmittedQPR&id="+qpr_submission.data.data.id, []);
        } catch (error) {
          console.log(error);
        }
        
        // Load notifications
        this.bus.$emit('fireMethod');
      }catch(error){
        console.log(error)
      }
      this.clearQPRForm();
    },

    setFoundDuring: function(data) {
      this.foundDuring = data;
    },

    checkVersion: function(){
      let versionRegex = /^[0-9]+(\.[0-9]+)*$/;
      if(versionRegex.test(this.softwareVersion)){
        this.validVersion = true;
      } else {
        this.validVersion = false;
      }
    },

    setProjects: function(value){
      if(value){
        this.projectOptions.forEach(project => {
          if(project.value == value){
            this.foundIn = project.text;
            this.softwareVersion = project.version;
          }
        })
      }
    },

    populateProjects: async function(){
      let token = this.$store.getters.getToken;
      let response = '';
      let query = 'filters[archived][$eq][0]=' + false;      
      try {
          response = await DatabaseLib.getRequest('strapiDatabase','projects',token,query);
      } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p19 = true;
          return;
      }
      this.projectOptions = [];
      for(let c = 0; c < response.data.data.length; c = c + 1){
        //if((this.$store.getters.getGroups.includes("Administration")) || (response.data.data[c].attributes.ProjectManager == this.$store.getters.getUser)){
          let obj = {};
          obj["text"] = response.data.data[c].attributes.ProjectName;
          obj["value"] = response.data.data[c].id;
          obj["version"] = response.data.data[c].attributes.version;
          if (this.projectName === obj.value)
          {
              obj["selected"] = true;
          }
          this.projectOptions.push(obj);
        //}
      }

      this.priorityOptions = [];
       for(var i = 0; i < 5; i++){
        let obj = {};
        obj["text"] = (i + 1).toString();
        obj["value"] = (i + 1).toString();
        this.priorityOptions.push(obj);
      }
    },

    setUser: async function(){
      let token = this.$store.getters.getToken;
      let response = await DatabaseLib.getRequest('strapiDatabase','users/me',token,"populate[0]=groups");
      this.author = response.data.firstName + " " + response.data.lastName;
      for(var i = 0; i < response.data.groups.length; i++){
        if(response.data.groups[i].name == "Employee"){
          this.company = "Quadrus Corporation";
          break;
        }
      }
    },
  }, 
  watch: {
    currentFunction: function() {
      if(200 - this.currentFunction.length <= 100 && 200 - this.currentFunction.length > 50) {
        this.currentCharStyle = '#FF8800';
      } else if (200 - this.currentFunction.length <= 50) {
        this.currentCharStyle = '#CC0000';
      } else {
        this.currentCharStyle =  '#007E33';
      }
    },
    expectedFunction: function() {
      if(200 - this.expectedFunction.length <= 100 && 200 - this.expectedFunction.length > 50) {
        this.expectedCharStyle = '#FF8800';
      } else if (200 - this.expectedFunction.length <= 50) {
        this.expectedCharStyle = '#CC0000';
      } else {
        this.expectedCharStyle =  '#007E33';
      }
    }
  },
  mounted(){
    this.populateProjects();
    this.setUser();
  }
}
</script>